import axios from 'axios';
import { headers } from './TokenHeader';
import { Urls } from './ApiPath';
import { Auth } from "../auth/Auth";
const API_KEY = process.env.REACT_APP_API_KEY;
const options = {
	headers: {'x-access-token': Auth.token()}
  };
const findAll = () => {
	return new Promise((resolve, reject) => {
		axios
			.get(`${Urls.drugSubCategories.v3.findAll}`,{headers:headers})
			.then((response) => {
				resolve(response.data);
			})
			.catch((error) => {
				reject(error);
			});
	});
};

const save = (category ,isImage, onUploadProgress) => {
	return new Promise((resolve, reject) => {
		generateFormData(category ,isImage, -1 , (formData) => {
			console.log(formData)
			axios
				.post(Urls.drugSubCategories.v3.save, formData, { headers: headers , onUploadProgress})
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					reject(error);
				});
		})
	});
};

const edit = (category , isStatus,id , onUploadProgress ) => {
	return new Promise((resolve, reject) => {
		generateFormData(category,isStatus ,id , (formData) => {
			axios
				.put(Urls.drugSubCategories.v3.edit, formData, { headers: headers , onUploadProgress})
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					reject(error);
				});
		})
	});
};


const generateFormData = (category ,isStatus ,id , cb) => {
	const data = new FormData();
	id>-1 && 	data.append('id', id);
	data.append('status' , category.status)
	if(!isStatus){
		data.append('image', category.image);
	}
	data.append('title', category.title);
	data.append('description', category.description)
	data.append('DrugCategoryId', category.DrugCategoryId);
	cb(data)
}


const findOneById = (id) => {
	return new Promise((resolve, reject) => {
		axios
			.get(`${Urls.drugSubCategories.v3.findOneById}/${id}`,{headers:headers})
			.then((response) => {
				resolve(response.data);
			})
			.catch((error) => {
				reject(error);
			});
	});
};

const addItem = (item ) => {
	return new Promise((resolve, reject) => {
		axios.post(Urls.drugSubCategories.v3.addItem, item , { headers: headers })
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					reject(error);
		});
	});
};

const removeItem = (item ) => {
	return new Promise((resolve, reject) => {
		axios.post(Urls.drugSubCategories.v3.removeItem, item , { headers: headers })
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					reject(error);
		});
	});
};


export const DrugSubCategoryService = {
	findAll: findAll,
	save: save,
	edit,
	findOneById,
	addItem,
	removeItem
}